export class Maps {

    constructor ( target = '.js-map', options = {} ) {

        this.target = target

        this.options = {
            mapTypeControl: true,
            streetViewControl: false,
            fullscreenControl: false,
            overviewMapControl: true,
            scaleControl: true,
            mapTypeControlOptions: {
                mapTypeIds: []
            },
            ...options
        };
    }

    init () {
        this.containers = Array.from( document.querySelectorAll( this.target ) );

        document.addEventListener( 'mapLoaded', this.create.bind( this ) );

    }

    create ( event ) {
        const google = event.detail.googleApi;

        this.generate( google );
    }

    generate ( google ) {
        this.options.zoomControlOptions = { style: google.maps.ZoomControlStyle.DEFAULT },
            this.containers.forEach( container => {

                const lat = container.getAttribute( 'data-lat' );
                const lng = container.getAttribute( 'data-lng' );

                this.map = new google.maps.Map( container, {
                    center: new google.maps.LatLng( lat, lng ),
                    zoom: 14,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: false,
                } );

                this.map.setOptions( this.options );

                const contentString = `
                <div style="color: #141B4D">
                    <p>Blackwell House<p>
                    <p>Guildhall Yard<p>
                    <p>London<p>
                    <p>EC2V5AE</p>
                </div>
                `;

                var infowindow = new google.maps.InfoWindow( {
                    content: contentString
                } );

                this.marker = new google.maps.Marker( {
                    animation: google.maps.Animation.DROP,
                    position: this.map.getCenter(),
                    map: this.map,
                    draggable: false,
                    optimized: false,
                } );

                infowindow.open(this.map, this.marker);
            } )
    }

    destroy () {
    }
}
